const accessTokens = {
    sessionToken: '',
    reactToken: '',
};

export const setAuthToken = (key: 'sessionToken' | 'reactToken', token: string) => {
    accessTokens[key] = token;
};

export const getAuthTokens = () => accessTokens;